import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitMenuItemInterface } from '../../module/benefits/nav/BenefitMenuItem';
import { BenefitNavigationExtensionInterface } from '../interface/benefit-navigation.extension.interface';

export class BikeleasingBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.BikeleasingV2.toLowerCase();

    return [
      { title: 'subPage.employees', to: `/benefits/${benefit}` },
      {
        title: 'extensions:bikeleasing_v2_benefit.contracts',
        to: `/benefits/${benefit}/contracts`,
        activePattern: `^/benefits/${benefit}/(contracts(?:$|/)|employees/[^/]+/contracts(?:$|/))`,
      },
      { title: 'extensions:bikeleasing_v2.insurance.title', to: `/benefits/${benefit}/insurances` },
      { title: 'extensions:bikeleasing_v2.settings.title', to: `/benefits/${benefit}/settings` },
      { title: `subPage.payrollReport`, to: `/benefits/${benefit}/payrollReport` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
      { title: 'extensions:bikeleasing_v2.information.title', to: `/benefits/${benefit}/information` },
    ];
  }
}
